import { typeGuard } from '@/lib/utils';
import type { OrganizationUser } from '@pigello/pigello-matrix';
import { ORGANIZATION_USER_DETAIL_ACCESS } from './constants';

/**
 * Returns the display name for an {@link OrganizationUser}.
 * External users (detailAccess === 2) display corporateName if present, otherwise fall back to communicationName.
 * Non-external users display communicationName if present, otherwise return '-'.
 * Both branches may fall back to '-' when no name is available.
 */
export function getOrganizationUserName(
  data: OrganizationUser | undefined | null
): string {
  if (!data) {
    return '-';
  }
  // If the user is external we show their corporate name
  if (data.detailAccess === ORGANIZATION_USER_DETAIL_ACCESS.EXTERNAL) {
    return data.corporateName || data.communicationName || '-';
  }
  return data.communicationName || '-';
}

export function isOrganizationUser(data: unknown): data is OrganizationUser {
  return typeGuard<OrganizationUser>(data, 'detailAccess');
}
